import React, { useState } from 'react';
import cn from 'classnames';

import { Select as AntSelect } from 'antd';
import type { SelectProps } from 'antd/lib/select';
import { AngleDownIcon } from '@revfluence/fresh-icons/regular';

import styles from './Select.module.scss';

export interface ISelectProps<T> extends SelectProps<T> {
  shortCombo?: boolean;
  mode?: 'multiple' | 'tags';
  suffixIcon?: React.ReactElement;
}

export function Select<SelectValue>(
  props: ISelectProps<SelectValue>
): React.ReactElement {
  const { shortCombo, className, suffixIcon = <AngleDownIcon /> } = props;
  const [open, setOpen] = useState(false);

  const customSuffixIcon = React.cloneElement(suffixIcon, {
    onClick: () => setOpen(!open),
  });

  return (
    <AntSelect<SelectValue>
      className={cn(
        styles.Select,
        { [styles['short-combo']]: shortCombo },
        className
      )}
      dropdownStyle={{ width: 'auto' }}
      dropdownMatchSelectWidth={false}
      {...props}
      suffixIcon={customSuffixIcon}
      open={open}
      onDropdownVisibleChange={(o) => setOpen(o)}
    />
  );
}

Select.Option = AntSelect.Option;
Select.OptGroup = AntSelect.OptGroup;
